module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("TREE LORE")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("BY")])]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("FRANCIS GEORGE HEATH")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Editor of"), _c('br'), _vm._v("Gilpin’s ‘Forest Scenery’"), _c('br'), _vm._v("Author of"), _c('br'), _vm._v("‘Our Woodland Trees,’ ‘Burnham Beeches,’ ‘The Fern Portfolio,"), _c('br'), _vm._v("‘The Fern World,’ ‘Tree Gossip,’ ‘Sylvan Spring,’ ‘Sylvan"), _c('br'), _vm._v("Winter,’ ‘Autumnal Leaves,’ ‘My Garden Wild,’ ‘The"), _c('br'), _vm._v("Green Gateway,’ ‘Peasant Life,’ ‘Garden Rockery,’"), _c('br'), _vm._v("‘The Fern Paradise,’ ‘Fairy Plants,’"), _c('br'), _vm._v("‘Our British Rural Life and Labour,’"), _c('br'), _vm._v("‘British Trees,’ ‘British Ferns,’"), _c('br'), _vm._v("&c., &c."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.gif"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a4834e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 60
// module chunks = 0